import { connect } from 'react-redux';

import EndOperation from './end-operation.component';
import { IEndOperationStoreProps } from 'modules/end-operation/end-operation.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IEndOperationStoreProps => ({
    endDate: state.friendsReferral.campaignInfo.endDate,
    isRegistered: state.friendsReferral.playerInfo.isReferrer,
    softCloseMode: state.friendsReferral.campaignInfo.softCloseMode,
    shouldInheritStyles: state.config.shouldInheritStyles
});

const Container = connect(
    mapStateToProps
)(EndOperation);

export default Container;
